import React, { useEffect } from "react";
import { useHistory } from "react-router";
import "./index.scss";
import {ROUTES} from "../../db/models/const";
import {useSelector} from "react-redux";
import {selectUser} from "../../slices/profile";
import { studentFollowingRmIdArray } from "../../helpers/student";

interface Props {}

export const StudentMe: React.FC<Props> = () => {
	const user = useSelector(selectUser);
	const history = useHistory();

	useEffect(() => {
		if (user?.bounded) {
			history.push(ROUTES.STUDENT_AFOL);
            return;
		} else {
			const followIds = Object.keys(user?.follows || {});

			if (followIds.length > 0) {
				history.push(ROUTES.FOLLOW.replace(":rmId", followIds[0]));
				return;
			} else {
				history.push(ROUTES.FEED);
				return;
			}
		}
	}, [user]);

	return null;
};
